Appartement =  {

	init : ->
		console.log 'Appartement init'

		_this = @

		$('*[reveal-infos]').on "click", (ev) ->
			# Activate close overlay
			$('.appartement--overlay-container').css('pointer-events', 'initial')

			# Show overlay animation
			tlShowOverlay = new TimelineLite
			tlShowOverlay.addLabel('start')
				.set($('.appartement--slider'),{autoAlpha:1}, 'start')
				.to($('.appartement--content .appartement--title'), 0.6, {x:-30, autoAlpha:0, ease:Quint.easeInOut})
				.to($('.appartement--content .cta'), 0.6, {x:-30, autoAlpha:0, ease:Quint.easeInOut}, 'start+=0.05')
				.add ->
					$('.appartement--overlay').addClass('active')
				, 'start+=0.3'
				.fromTo($('.appartement--slider .controls-container'), 0.6, {y:-30, autoAlpha:0}, {y:0, autoAlpha:1, ease:Quint.easeInOut})

		$('.appartement--overlay .cta_close').on "click", (ev) ->
			_this.closeOverlay()
		

	closeOverlay : ->
		# Disable close overlay
		$('.appartement--overlay-container').css('pointer-events', 'none')

		# Hide overlay animation
		$('.appartement--overlay').removeClass('active')
		tlHideOverlay = new TimelineLite
		tlHideOverlay.addLabel('start')
				.to($('.appartement--slider'), 0.6, {autoAlpha:0, ease:Quint.easeInOut}, 'start')
				.fromTo($('.appartement--slider .controls-container'), 0.6, {y:0, autoAlpha:1}, {y:30, autoAlpha:0, ease:Quint.easeInOut}, 'start')
				.to($('.appartement--content .cta'), 0.6, {x:0, autoAlpha:1, ease:Quint.easeInOut}, 'start')
				.to($('.appartement--content .appartement--title'), 0.6, {x:0, autoAlpha:1, ease:Quint.easeInOut}, 'start+=0.05')
				.add ->
					# Reinit slider position		
					$('.appartement--slider').find('[slick]').slick('slickGoTo', 0, false)
					$('.appartement--slider').find('.control_prev .control--nb').html("01")

		# Hide overlay (CSS anim)
		$('.appartement--overlay').removeClass('active')
	

	destroy : ->
		console.log "Appartement destroy"
		
}